// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-grey[data-v-516a6464]{border-bottom:2px solid #e0e0e0}.novelty-caption[data-v-516a6464]{font-size:1.2em;background-color:#000;color:#fff}", ""]);
// Exports
module.exports = exports;
